import dayjs from "dayjs";
import 'dayjs/locale/id';

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

dayjs.locale('id');

function _parseToDayjs(time) {
    if (!time) return null;
    let d = dayjs(time, "YYYY-MM-DD HH:mm:ss", true);
    if (!d.isValid()) {
        d = dayjs(time);
    }
    return d.isValid() ? d : null;
}

function _parseWib(time) {
    if (!time) return null;
    const d = dayjs.tz(time, "YYYY-MM-DD HH:mm:ss", "Asia/Jakarta");
    return d.isValid() ? d : null;
}

/**
 * Formats a given UTC time string into a human-readable local string (WIB).
 * @param {string | number | Date} time - The UTC timestamp to format.
 * @returns {string | undefined} Formatted date string or original input if invalid.
 */
export function convertTime(time) {
    const date = _parseWib(time);
    if (!date) return time;
    return date.format("dddd, D MMMM YYYY HH:mm [WIB]");
}

/**
 * Converts a timestamp into a "time ago" string (e.g., "2 jam yang lalu").
 * @param {string | number | Date} time - The timestamp to compare.
 * @returns {string} The relative time string.
 */
export function timeAgo(time) {
    const date = _parseWib(time);
    if (!date) return 'Invalid date';
    return date.fromNow();
}

/**
 * Takes a date and formats it as a UTC string, ideal for sending to a server.
 * @param {string | number | Date} [time=Date.now()] - The time to format. Defaults to now. 
 * @returns {string} The UTC formatted string (ISO 8601).
 */
export function formatUtc(time = Date.now()) {
    const date = _parseToDayjs(time);
    if (!date) return null;

    return date.utc().format();
}


export default {
    install(app) {
        app.config.globalProperties.$convertTime = convertTime;
        app.config.globalProperties.$timeAgo = timeAgo;
        app.config.globalProperties.$formatUtc = formatUtc; 
    }
};